import { createContext, useContext } from 'react'
import { type MainModule } from './mainModule.ts'

export const AppContext = createContext<MainModule>({} as never)

export function useAppModule() {
  return useContext(AppContext)
}
